export default __webpack_public_path__ + "static/media/qrcode-color.415ae70d.svg";